// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  mapId: __t.string(),
  atlasId: __t.string(),
  worldX: __t.i32(),
  worldY: __t.i32(),
  mode: __t.string(),
  variantId: __t.string(),
  flipHorizontal: __t.bool(),
  flipVertical: __t.bool(),
  rotationSteps: __t.i32(),
};
